import { mapGetters, mapState } from "vuex";
const DEFAULT_PAGING = {
  page: 1,
  page_size: 10
};
export const categoryTableWrapper = {
  props: {
    searchParamName: {
      type: String,
      default: "category_name"
    },
    searchLabel: {
      type: String,
      default: function() {
        return this.$t("message.reviews.categories.categorySearchLabel");
      }
    },
    name: {
      type: String
    },
    groups: {
      type: Array
    },
    fetchMethod: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      gridData: {
        basic: {
          results: [],
          count: 0
        },
        comparison: {
          results: [],
          count: 0
        }
      },
      isLoading: false,
      paging: DEFAULT_PAGING,
      filters: {}
    };
  },
  computed: {
    ...mapGetters("reviewsCategoriesAnalytics", [
      "isComparing",
      "getFacilityParams",
      "getSelectedDate",
      "getComparisonDate"
    ]),
    ...mapState("reviewsCategoriesAnalytics", ["isAutoCategorized"]),
    isAutoCategorizedParam() {
      return {
        is_auto_categorized: this.isAutoCategorized || undefined
      };
    },
    tableContainerEvents() {
      return {
        "group-change": this.groupChangeHandler,
        search: this.searchHandler,
        sort: this.sortHandler,
        "page-change": this.pageChangeHandler
      };
    },
    tableContainerAttrs() {
      return {
        tableAttrs: this.tableAttrs,
        groups: this.groups,
        isLoading: this.isLoading,
        searchBoxAttrs: this.searchBoxAttrs
      };
    },
    tableAttrs() {
      return {
        name: this.name,
        headers: this.headers,
        data: this.formattedGridData,
        paging: this.paging
      };
    },
    searchBoxAttrs() {
      return {
        searchLabel: this.searchLabel,
        searchParamName: this.searchParamName,
        isLoading: this.isLoading
      };
    },
    basicFilters() {
      return {
        ...this.getFacilityParams,
        ...this.getSelectedDate,
        ...{ tag_id: this.$route.query.tag_id },
        ...this.paging,
        ...(this.groups && { group_by: this.groups[0].value }),
        ...this.defaultFilters,
        ...this.filters,
        ...this.isAutoCategorizedParam
      };
    },
    comparisonFilters() {
      if (!this.getComparisonDate) return;
      return {
        ...this.basicFilters,
        ...this.getComparisonDate
      };
    }
  },
  async created() {
    await this.getGridData();
  },
  methods: {
    groupChangeHandler(group) {
      this.paging = DEFAULT_PAGING;
      this.filters = {
        ...this.filters,
        ...group,
        ...this.paging
      };
    },
    searchHandler(search) {
      this.paging = DEFAULT_PAGING;
      this.filters = {
        ...this.filters,
        ...this.paging,
        ...search
      };
    },
    sortHandler(sort) {
      this.paging = DEFAULT_PAGING;

      this.filters = {
        ...this.filters,
        ...sort,
        ...this.paging
      };
    },
    pageChangeHandler(paging) {
      this.paging = paging;
      this.filters = {
        ...this.filters,
        ...paging
      };
    },
    isRowActionAllowed(item) {
      return this.gridData.basic.results.indexOf(item) !== 1;
    },
    async fetchGridData(
      basicFilters = this.basicFilters,
      comparisonFilters = this.comparisonFilters
    ) {
      if (!comparisonFilters) {
        const basicData = await this.fetchMethod(basicFilters);
        return [basicData];
      }
      const [basicData, comparisonData] = await Promise.all([
        this.fetchMethod(basicFilters),
        this.fetchMethod(comparisonFilters)
      ]);
      return [basicData, comparisonData];
    },
    clearComparison() {
      this.gridData.comparison.results = [];
      this.gridData.comparison.count = 0;
    },
    async getGridData() {
      this.isLoading = true;
      const [basicData, comparisonData] = await this.fetchGridData();
      this.gridData.basic = basicData;
      if (comparisonData) {
        this.gridData.comparison = comparisonData;
      }
      this.isLoading = false;
      this.formattedGridData = this.getFormattedGridData();
    }
  },
  watch: {
    isComparing(current) {
      if (!current) {
        this.clearComparison();
      }
    }
  }
};
